<template>
  <div class="p-6">
    <ContactInfo />
  </div>
</template>

<script>
import ContactInfo from '@/components/ContactInfo.vue'

export default {
  components: { ContactInfo }
}
</script>
